// C:\Users\ignac\OneDrive\Escritorio\imagenes_productos\callcenter3\src\App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import LoginForm from './components/LoginForm';
import Dashboard from './pages/Dashboard';
import Pedidos from './pages/Pedidos';
import PedidosHistoricos from './pages/PedidosHistoricos';
import Moviles from './pages/Moviles';
import EnviarMensajesTelegram from './pages/EnviarMensajesTelegram';
import GoogleCallCenterMap from './pages/GoogleCallCenterMap';
import UsuariosRegistrados from './telegram/UsuariosRegistrados';
import PedidosRealizados from './telegram/PedidosRealizados';
import GestionUsuarios from './pages/GestionUsuarios';
import RutaMoviles from './pages/RutaMoviles';
import ProtectedRoute from './ProtectedRoute';
import GPS from './pages/GPS';
import { DarkModeProvider } from './components/DarkModeContext';
import { LoadScript } from '@react-google-maps/api';
import './styles/googleMapsOverrides.css';

// API key global (usa la misma para toda la aplicación)
const googleMapsApiKey = 'AIzaSyBcUE3zRi5BtrcPo3ilC3fj1lFRMCXNYyg';

function App() {
  return (
    <DarkModeProvider>
      {/* Carga la API de Google Maps una sola vez para toda la app */}
      <LoadScript googleMapsApiKey={googleMapsApiKey} libraries={['places']}>
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="/login" element={<LoginForm />} />
            <Route
              path="/welcome/*"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="pedidos" element={<Pedidos />} />
              <Route path="pedidos-historicos" element={<PedidosHistoricos />} />
              <Route path="moviles" element={<Moviles />} />
              {/* GoogleCallCenterMap usará la API global */}
              <Route path="google-callcenter-map" element={<GoogleCallCenterMap />} />
              <Route path="usuarios-registrados" element={<UsuariosRegistrados />} />
              <Route path="pedidos-realizados" element={<PedidosRealizados />} />
              <Route
                path="ruta-moviles"
                element={
                  <ProtectedRoute roles={['Administrador']}>
                    <RutaMoviles />
                  </ProtectedRoute>
                }
              />
              <Route
                path="enviar-mensajes"
                element={
                  <ProtectedRoute roles={['Administrador']}>
                    <EnviarMensajesTelegram />
                  </ProtectedRoute>
                }
              />
              <Route
                path="gestion-usuarios"
                element={
                  <ProtectedRoute roles={['Administrador']}>
                    <GestionUsuarios />
                  </ProtectedRoute>
                }
              />
              <Route
                path="gps"
                element={
                  <ProtectedRoute roles={['Administrador', 'Supervisor']}>
                    <GPS />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<div>404 - Página no encontrada</div>} />
          </Routes>
        </Router>
      </LoadScript>
    </DarkModeProvider>
  );
}

export default App;
